// extracted by mini-css-extract-plugin
export default {"container":"wq-z","ratingLayout":"xq-z","ratingLabel":"yq-z","nonInteractiveRatingLabel":"zq-z"};